import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {SimpleDropdown} from '../../../libs/shared/ui/src/components/dropdowns/simpleDropdown';
import {SimpleDropdownItem} from '../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItem';
import {SimpleDropdownItemWithColor} from '../../../libs/shared/ui/src/components/dropdowns/simpleDropdownItemWithColor';
import {PopoverTransferProps} from '../../../libs/shared/ui/src/components/popovers/popoverCoordinator';
import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';

/*
 * Props.
 */

interface SettingsTagsListTableDropdownProps extends PopoverTransferProps {
  onEditTagSelect: Handler;
  onNestUnderSelect: Handler;
  onAddSubtagSelect: Handler;
  onDeleteSelect: Handler;
  onArchiveSelect: Handler;
  onRestoreSelect: Handler;
  isInArchivedView: boolean;
}

/*
 * Component.
 */

export const SettingsTagsListTableDropdown: FC<SettingsTagsListTableDropdownProps> = (props) => {
  const {
    anchor,
    onRequestClose,
    onEditTagSelect,
    onNestUnderSelect,
    onAddSubtagSelect,
    onDeleteSelect,
    onArchiveSelect,
    onRestoreSelect,
    isInArchivedView,
  } = props;

  if (isInArchivedView) {
    return (
      <SimpleDropdown anchor={anchor} onRequestClose={onRequestClose}>
        <SimpleDropdownItem onSelect={onRestoreSelect}>
          <Trans id="settingstags-restore">Restore</Trans>
        </SimpleDropdownItem>
        <SimpleDropdownItemWithColor color={PaletteColorsEnum.RED} onSelect={onDeleteSelect}>
          <Trans id="settingstags-delete">Delete</Trans>
        </SimpleDropdownItemWithColor>
      </SimpleDropdown>
    );
  }

  return (
    <SimpleDropdown anchor={anchor} onRequestClose={onRequestClose}>
      <SimpleDropdownItem onSelect={onEditTagSelect}>
        <Trans id="settingstags-edittag">Edit tag</Trans>
      </SimpleDropdownItem>
      <SimpleDropdownItem onSelect={onNestUnderSelect}>
        <Trans id="settingstags-nestunder">Nest under</Trans>
      </SimpleDropdownItem>
      <SimpleDropdownItem onSelect={onAddSubtagSelect}>
        <Trans id="settingstags-addsubtag">Add a subtag</Trans>
      </SimpleDropdownItem>
      <SimpleDropdownItem onSelect={onArchiveSelect}>
        <Trans id="settingstags-archive">Archive</Trans>
      </SimpleDropdownItem>
      <SimpleDropdownItemWithColor color={PaletteColorsEnum.RED} onSelect={onDeleteSelect}>
        <Trans id="settingstags-delete">Delete</Trans>
      </SimpleDropdownItemWithColor>
    </SimpleDropdown>
  );
};
